export function numberToWord (value) {
  let stringValue = ''
  let negative = ''
  if (value < 0) {
    negative = 'Хасах '
    value = Math.abs(value)
  }
  const strMynga = 'мянга'
  const strSay = 'сая'
  const strTerbum = 'тэрбум'
  const strIhnayad = 'их наяд'
  let strMoney = value.toString()
  const strMons = []
  if (strMoney.length > 15) { throw new Error('Мөнгөн дүн хэтэрхий их байна.') }
  if (strMoney.length > 3) { } else { strMons.push(strMoney) }
  while (strMoney.length > 3) {
    strMons.push(strMoney.substring(strMoney.length - 3, strMoney.length))
    strMoney = strMoney.substring(0, strMoney.length - 3)
    if (strMoney.length > 3) { } else { strMons.push(strMoney) }
  }
  for (let i = strMons.length - 1; i >= 0; i--) {
    let addstr = ''
    switch (i) {
      case 1: addstr = strMynga; break
      case 2: addstr = strSay; break
      case 3: addstr = strTerbum; break
      case 4: addstr = strIhnayad; break
      default: break
    }
    const treevalue = subNumberToWordNumber(strMons[i], i === 0, strMons.length, i)
    stringValue = stringValue + ' ' + treevalue + ' ' + (treevalue === '' && (strMons.length !== i + 1) ? '' : addstr)
  }
  stringValue = negative + stringValue.trim().replace('  ', ' ').replace('  ', ' ')
  let dddd = stringValue.substring(0, 1).toUpperCase() + stringValue.substring(1)
  if (dddd.length >= 5) {
    if (dddd.substring(dddd.length - 5).toUpperCase() === strMynga.toUpperCase()) {
      dddd += 'н'
    }
  }
  return dddd
}
function subNumberToWordNumber (strMoney, isLast, count, current) {
  const strNegj = ['тэг', 'нэг', 'хоёр', 'гурван', 'дөрвөн', 'таван', 'зургаан', 'долоон', 'найман', 'есөн']
  const strNegjen = ['', 'нэг', 'хоёр', 'гурван', 'дөрвөн', 'таван', 'зургаан', 'долоон', 'найман', 'есөн', '']
  const strArav = ['', 'арван', 'хорин', 'гучин', 'дөчин', 'тавин', 'жаран', 'далан', 'наян', 'ерөн', '']
  const strArvan = ['', 'арван', 'хорин', 'гучин', 'дөчин', 'тавин', 'жаран', 'далан', 'наян', 'ерөн', '']
  const strZuu = 'зуун'
  const strZuun = 'зуун'
  let stringValue = ''
  strMoney = parseInt(strMoney).toString()
  const len = strMoney.toString().length
  if (parseInt(strMoney) === 0) {
    return isLast && count === 1 ? strNegj[0] : strNegjen[0]
  }
  if (len === 1) {
    const ff = parseInt(strMoney.substring(0, 1))
    if (!isLast && ff === 1) {
      if ((count === current + 1)) {
        stringValue = ''
      } else {
        stringValue = strNegj[ff]
      }
    } else {
      stringValue = isLast ? strNegj[ff] : strNegjen[ff]
    }
  }
  if (len === 2) {
    if (parseInt(strMoney.substring(1, 2)) === 0) { stringValue = isLast ? strArav[parseInt(strMoney.substring(0, 1))] : strArvan[parseInt(strMoney.substring(0, 1))] } else {
      const index1 = parseInt(strMoney.substring(0, 1))
      const index2 = parseInt(strMoney.substring(1, 2))
      stringValue = strArvan[index1] + ' ' + (isLast ? strNegj[index2] : (index2 === 1 && index1 !== 0 ? 'нэгэн' : strNegjen[index2]))
    }
  }
  if (len === 3) {
    if (parseInt(strMoney.substring(1, 3)) === 0) {
      if (parseInt(strMoney.substring(0, 1)) !== 1) { stringValue = strNegjen[parseInt(strMoney.substring(0, 1))] + ' ' + (isLast ? strZuu : strZuun) } else {
        stringValue = isLast ? strZuu : strZuun
      }
    } else {
      if (parseInt(strMoney.substring(0, 1)) !== 1) {
        stringValue = strNegjen[parseInt(strMoney.substring(0, 1))] + ' ' + strZuun
      } else {
        stringValue = count === current + 1 ? strZuun : strNegjen[parseInt(strMoney.substring(0, 1))] + ' ' + strZuun
      }
      if (parseInt(strMoney.substring(2, 3)) === 0) { stringValue = stringValue + ' ' + (isLast ? strArav[parseInt(strMoney.substring(1, 2))] : strArvan[parseInt(strMoney.substring(1, 2))]) } else {
        const index1 = parseInt(strMoney.substring(1, 2))
        const index2 = parseInt(strMoney.substring(2, 3))
        stringValue = stringValue + ' ' + strArvan[index1] + ' ' + (isLast ? strNegj[index2] : (index2 === 1 && index1 !== 0 ? 'нэгэн' : strNegjen[index2]))
      }
    }
  }
  return stringValue
}
